import { render, staticRenderFns } from "./alermDes2.vue?vue&type=template&id=70941cec&scoped=true&"
import script from "./alermDes2.vue?vue&type=script&lang=js&"
export * from "./alermDes2.vue?vue&type=script&lang=js&"
import style0 from "./alermDes2.vue?vue&type=style&index=0&id=70941cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70941cec",
  null
  
)

component.options.__file = "alermDes2.vue"
export default component.exports